import React, { useState } from 'react';
import { buildTrackerStyleFromCrmEntry } from '../../pages/customers/voiceBotTrackerSummary';
import { renderMarkdownNotes } from './callSummaryMarkdown';
import styles from '../../pages/customers/CustomerDetailsModal.module.scss';

export default function CallSummaryItem({ entry, onDelete, isDeleting, trackerParts }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const parts = trackerParts || buildTrackerStyleFromCrmEntry(entry);
  const whenLabel = entry.formatted || entry.time || '';
  const badge = parts.awaiting
    ? { label: 'Awaiting Vobiz', color: '#b45309', bg: '#fef3c7' }
    : parts.fallback
      ? { label: 'Transcript fallback', color: '#a16207', bg: '#fef9c3' }
      : parts.isFinal
        ? { label: 'Vobiz final', color: '#15803d', bg: '#dcfce7' }
        : null;

  return (
    <li className={styles.callSummaryItem}>
      {whenLabel ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <button
            type="button"
            className={styles.callSummaryWhen}
            onClick={() => setIsExpanded(!isExpanded)}
            style={{ flex: 1, textAlign: 'left' }}
          >
            <span>
              <i className="fa fa-clock-o" style={{ marginRight: '0.4rem' }} />
              {whenLabel}
            </span>
            {badge ? (
              <span
                style={{
                  marginLeft: '0.5rem',
                  fontSize: '0.68rem',
                  fontWeight: 700,
                  color: badge.color,
                  background: badge.bg,
                  borderRadius: 999,
                  padding: '0.12rem 0.45rem',
                }}
              >
                {badge.label}
              </span>
            ) : null}
            <i className={`fa fa-chevron-${isExpanded ? 'up' : 'down'}`} style={{ color: '#6366f1', marginLeft: '0.5rem' }} />
          </button>
          {!showConfirm && onDelete ? (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); setShowConfirm(true); }}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#94a3b8', padding: '0.25rem 0.4rem', marginLeft: '0.4rem',
                borderRadius: '6px', fontSize: '0.8rem',
              }}
              title="Delete this entry"
            >
              <i className="fa fa-trash-o" />
            </button>
          ) : null}
        </div>
      ) : null}
      {(!whenLabel || isExpanded) && (parts.summaryText || parts.notesMarkdown) ? (
        <div className={styles.callSummaryBody}>
          {parts.summaryText ? (
            <div
              style={{
                marginBottom: parts.notesMarkdown ? '0.65rem' : 0,
                padding: '0.65rem 0.75rem',
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: 8,
                fontSize: '0.85rem',
                lineHeight: 1.5,
                color: '#1e293b',
              }}
            >
              <div style={{ fontSize: '0.7rem', color: '#64748b', marginBottom: 4, fontWeight: 600 }}>
                Summary
              </div>
              {parts.summaryText}
            </div>
          ) : null}
          {parts.notesMarkdown ? renderMarkdownNotes(parts.notesMarkdown) : null}
        </div>
      ) : null}
    </li>
  );
}
